export const SET_TOKEN = 'SET_TOKEN';
export const UPDATE_USERINFO = 'UPDATE_USERINFO';
export const SET_ROUTERS = 'SET_ROUTERS';
export const INIT_ROUTERS = 'INIT_ROUTERS';
export const ROUTERS_DONE = 'ROUTERS_DONE';
